module.exports = __webpack_public_path__ + "static/media/Albondigascerdo.7de4e3ad.jpg";